import Swup from 'swup';
// import SwupScriptsPlugin from '@swup/scripts-plugin/dist/SwupScriptsPlugin.min';
// import Splide from '@splidejs/splide';
import Alpine from 'alpinejs';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
// import 'photoswipe/style.css';



// const lightbox = new PhotoSwipeLightbox({
//   gallery: '#my-gallery',
//   children: 'a',
//   pswpModule: () => import('photoswipe')
// });
// lightbox.init();


// const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

const options = {
  plugins: [
    // new SwupScriptsPlugin()
  ]
};

const swup = new Swup(options);

// Events
swup.hooks.on('content:replace', init);

// Start Apline after swup so it works correctly
window.Alpine = Alpine
Alpine.start();

document.addEventListener("DOMContentLoaded", () => {
  l('ready');
  // checkCookie();
  init();
});

// Functions 
function l(m) {
  console.log(m);
}


function startLightbox() {

  if (document.querySelectorAll('#gallery').length) {
    l('startLightbox');
    const lightbox = new PhotoSwipeLightbox({
      gallery: '#gallery',
      children: 'a',
      pswpModule: () => import('photoswipe')
    });
    lightbox.init();
  }
}

function init() {
  l('👍');
  startLightbox()
  // startSliders();
  // cookieNotice();
}

// function cookieNotice() {
//   l('cookienotice');
//   document.querySelector('.cookie_btn').addEventListener('click', setCookie);
// }

// function setCookie() {
//   l('set cookie');
//   document.cookie = 'cookie-note=1;max-age=864000';
//   document.querySelector('.cookie').classList.add('hidden');
// }